"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contextMenuNovoDark = exports.contextMenuNovo = exports.contextMenu = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const contextMenu = {
    contextMenuBackground: color_const_1.default.white,
    contextMenuBorder: `1px solid ${color_const_1.default.cloudyBlue300}`,
    contextMenuBoxShadow: `0px 1px 5px ${(0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.1)}`,
    contextMenuFontFamily: font_const_1.default.family,
    contextMenuFontSize: font_const_1.default.sizeSm,
    contextMenuZIndex: zIndex_const_1.default.z1000,
    contextMenuItemColor: color_const_1.default.pickledBluewood800,
    contextMenuItemDisabledColor: color_const_1.default.steel700,
    contextMenuWidth: undefined,
    contextMenuItemWidth: `246px`,
    contextMenuItemHoverColor: color_const_1.default.dodgerBlue100,
    contextMenuItemDisabledHoverColor: 'transparent',
    contextMenuItemColorActive: color_const_1.default.dodgerBlue,
    contextMenuBorderRadius: '0px',
    contextMenuPadding: undefined,
    contextMenuItemPadding: undefined,
    isClassic: true,
};
exports.contextMenu = contextMenu;
const contextMenuNovo = {
    isClassic: false,
    ...novo.body02,
    contextMenuZIndex: 1000,
    contextMenuItemWidth: undefined,
    contextMenuWidth: '160px',
    contextMenuPadding: `${novo.spacing03} 0`,
    contextMenuItemPadding: `${novo.spacing03} ${novo.spacing05}`,
    contextMenuBackground: novo.ui06,
    contextMenuBorder: `1px solid ${novo.ui01}`,
    contextMenuBorderRadius: '6px',
    contextMenuBoxShadow: `0px 1px 2px ${(0, polished_1.rgba)(novo.ui04, 0.25)}`,
    contextMenuItemColor: novo.textColor01,
    contextMenuItemDisabledColor: novo.disabled01,
    contextMenuItemColorActive: undefined,
    contextMenuItemHoverColor: novo.hover08,
    contextMenuItemDisabledHoverColor: 'transparent',
};
exports.contextMenuNovo = contextMenuNovo;
const contextMenuNovoDark = {
    ...contextMenuNovo,
    contextMenuBackground: novoDark.ui06,
    contextMenuBorder: `1px solid ${novoDark.ui01}`,
    contextMenuBoxShadow: `0px 1px 2px ${(0, polished_1.rgba)(novoDark.ui04, 0.25)}`,
    contextMenuItemColor: novoDark.textColor01,
    contextMenuItemDisabledColor: novoDark.disabled01,
    contextMenuItemColorActive: undefined,
    contextMenuItemHoverColor: novoDark.hover08,
    contextMenuItemDisabledHoverColor: 'transparent',
};
exports.contextMenuNovoDark = contextMenuNovoDark;
